/**
 * ProductEntry Page
 * 
 * Main product entry form page.
 * 
 * Requirements: 1.1, 8.1
 */

import { useAuth } from '../context/AuthContext';
import { ProductEntryForm } from '../components/ProductEntryForm';
import type { SubmitAction } from '../types/product';

export function ProductEntry() {
  const { user, logout } = useAuth();

  const handleSubmit = async (_action: SubmitAction) => {
    // Product submission will be implemented in Phase 9
    // For now, simulate a successful submission
    await new Promise(resolve => setTimeout(resolve, 500));
  };

  return (
    <div className="product-entry-page">
      <header className="page-header">
        <h1>WKS Product Entry</h1>
        <div className="user-info">
          <span>Welcome, {user?.displayName}</span>
          <button onClick={logout} className="logout-button">
            Sign Out
          </button>
        </div>
      </header>
      
      <main className="page-content">
        <ProductEntryForm onSubmit={handleSubmit} />
      </main>
    </div>
  );
}

export default ProductEntry;
